export class ProjectType {
    Id: string;
    Title: string;
    Color: string;

    constructor() {
        this.Color = '#' + Math.floor(Math.random() * 16777215).toString(16);
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_models/project-type.model.ts